/*
 * https://www.algolia.com/doc/api-reference/widgets/menu-select/js/#widget-param-attribute
 */
import { menuSelect } from "instantsearch.js/es/widgets";
/*
 * Overriding default template to remove count
 *  '{{label}} ({{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}})'
 */
const itemTpl = `{{label}}`;
export const elementsTypes = menuSelect({
  container: '[data-elements-types]',
  attribute: 'Types',
  templates: {
    defaultOption: 'All Types',
    item: itemTpl,
    label: ''
  },
  cssClasses: {
    select: [

    ]
  }
})

export const elementsCategories = menuSelect({
  container: '[data-elements-categories]',
  attribute: 'Categories',
  templates: {
    defaultOption: 'All Categories',
    item: itemTpl,
    label: ''
  },
  cssClasses: {
    select: [

    ]
  }
})

export const elementsTechnology = menuSelect({
  container: '[data-elements-technology]',
  attribute: 'Technology',
  templates: {
    defaultOption: 'All Technology',
    item: itemTpl,
    label: ''
  },
  cssClasses: {
    select: [

    ]
  }
})
